import {
  TaxSetupQuestion,
  TaxSetupValues,
} from "v2/constants/taxSetupQuestions";

const toArray = (value: unknown): string[] =>
  Array.isArray(value) ? value : [];

const isFollowUpVisible = (
  question: TaxSetupQuestion,
  value: unknown
): boolean => {
  if (question.type === "multi") return toArray(value).length > 0;

  const triggers = question.followUp?.triggerValues ?? [];

  return typeof value === "string" && triggers.includes(value);
};

export const collectVisibleQuestions = (
  questions: TaxSetupQuestion[],
  values: TaxSetupValues,
  namePrefix: string
): TaxSetupQuestion[] =>
  questions.flatMap((question) => {
    const value = values[`${namePrefix}${question.id}`];
    const { followUp, followUpGroups } = question;

    const followUps =
      followUp && isFollowUpVisible(question, value)
        ? collectVisibleQuestions([followUp.question], values, namePrefix)
        : [];

    const groupQuestions = (followUpGroups ?? [])
      .filter(
        (group) =>
          typeof value === "string" && group.triggerValues.includes(value)
      )
      .flatMap((group) =>
        collectVisibleQuestions(group.questions, values, namePrefix)
      );

    return [question, ...followUps, ...groupQuestions];
  });
